import React from "react";
import { RouteComponentProps, Redirect } from "react-router-dom";
import "./Locations.css";
import "../../App.css";
import HashLoader from "react-spinners/HashLoader";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import Input from "../../components/Input";
import SecButton from "../../components/SecButton";
import { fetchRetry } from "../../functions/request";
import Title from "../../components/Title";
import { MainContext } from "../../contexts/MainContext";
import ErrorMessage from "../../components/ErrorMessage";

type Props = {};
type ComposedProps = Props & { refreshNavbar: any } & RouteComponentProps<{
    clubId: string;
    locationId: string;
  }>;

export default class Locations extends React.Component<
  ComposedProps,
  {
    clubId: string;
    club: any;
    clubLoaded: boolean;
    locationId: string;
    locationName: string;
    change: boolean;
    updateLoading: boolean;
    redirect: null | string;
    deleteLoading: boolean;
    showConfirmationModal: boolean;
    errMsgDeleteLocation: null | string;
    errMsgSaveLocation: null | string;
  }
> {
  static contextType = MainContext;
  constructor(props: ComposedProps) {
    super(props);
    this.state = {
      clubId: this.props.match.params.clubId,
      club: {},
      clubLoaded: false,
      locationId: this.props.match.params.locationId,
      locationName: "",
      change: false,
      updateLoading: false,
      redirect: null,
      deleteLoading: false,
      showConfirmationModal: false,
      errMsgDeleteLocation: null,
      errMsgSaveLocation: null,
    };
  }

  componentDidMount = () => {
    this.requestClub();
  };

  componentDidUpdate = () => {
    const propsLocationId = this.props.match.params.locationId;
    if (this.state.locationId !== propsLocationId) {
      if (
        this.state.club.locations &&
        propsLocationId in this.state.club.locations
      ) {
        this.setState({ locationId: propsLocationId }, this.updateLocationData);
      } else {
        this.setState({ locationId: propsLocationId }, this.requestClub);
      }
    }
  };

  requestClub = () => {
    fetchRetry(
      "getClubFromId",
      {
        clubId: this.state.clubId,
      },
      1,
      5
    )
      .then(this.handleClub)
      .catch(this.handleError);
  };

  handleSuccessUpdate = ({ data }: any) => {
    this.setState({ updateLoading: false });
    if (data.success) {
      this.requestClub();
      this.props.refreshNavbar();
    } else {
      this.setState({ errMsgSaveLocation: data.errorMsgDe });
    }
  };

  handleClub = ({ data }: any) => {
    this.setState({ clubLoaded: true });
    if (data.success) {
      const club = data.data;
      this.setState(
        {
          club,
        },
        this.updateLocationData
      );
    }
  };

  updateLocationData = () => {
    if (
      this.state.locationId &&
      this.state.locationId in this.state.club.locations
    ) {
      const location = this.state.club.locations[this.state.locationId];
      this.setState(
        {
          locationName: location.name,
        },
        this.checkChange
      );
    }
  };

  updateLocation = () => {
    this.setState({ updateLoading: true });
    fetchRetry(
      "updateClubLocation",
      {
        clubId: this.state.clubId,
        locationId: this.state.locationId,
        name: this.state.locationName,
      },
      1,
      5
    )
      .then(this.handleSuccessUpdate)
      .catch(this.handleError);
  };

  handleError = (err: any) => {
    console.error(err);
  };

  handleLocationNameChange = (val: any) => {
    this.setState({ locationName: val }, this.checkChange);
  };

  checkChange = () => {
    this.setState({
      change:
        this.state.locationName !==
        this.state.club.locations[this.state.locationId].name,
    });
  };

  handleDeleteLocation = () => {
    this.setState({ showConfirmationModal: true });
  };

  hideConfirmationModal = () => {
    this.setState({ showConfirmationModal: false });
  };

  handleLocationDeleteConfirmed = () => {
    this.setState({ deleteLoading: true, showConfirmationModal: false });
    fetchRetry(
      "deleteClubLocation",
      {
        clubId: this.state.clubId,
        locationId: this.state.locationId,
      },
      1,
      5
    )
      .then(this.handleSuccessLocationDeleted)
      .catch(this.handleError);
  };

  handleSuccessLocationDeleted = ({ data }: any) => {
    this.setState({ deleteLoading: false });
    if (data.success) {
      this.context.createInfo(
        "Die Örtlichkeit wurde erfolgreich gelöscht.",
        "success",
        4
      );
      this.setState(
        {
          redirect: `/club-settings/${this.state.clubId}/locations`,
        },
        () => {
          this.updateLocationData();
          this.props.refreshNavbar();
        }
      );
    } else {
      this.setState({ errMsgDeleteLocation: data.errorMsgDe });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (!this.state.clubLoaded) {
      return (
        <>
          <div className="loading-container">
            <HashLoader color={"#c31924"} size={100} loading={true} />
          </div>
        </>
      );
    }
    return (
      <>
        <ConfirmationModal
          show={this.state.showConfirmationModal}
          handleClose={this.hideConfirmationModal}
          title="Bist du sicher?"
          msg={`Willst du die Örtlichkeit "${
            this.state.locationId &&
            this.state.club?.locations &&
            this.state.club?.locations[this.state.locationId]?.name
              ? this.state.club.locations[this.state.locationId].name
              : "-"
          }" wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.`}
          handleConfirm={this.handleLocationDeleteConfirmed}
        />
        <div className="subscreen-branch-inner-container">
          <div className="subscreen-main-container">
            {this.state.locationId &&
              this.state.club?.locations &&
              Object.keys(this.state.club.locations).length > 0 && (
                <>
                  <div className="subscreen-box-container">
                    <Title title="Einstellungen" />
                    <div className="branch-subtitle-container">
                      <h3>Name</h3>
                    </div>
                    <Input
                      name="role-name-input"
                      value={this.state.locationName}
                      placeholder="Örtlichkeit name"
                      onChange={this.handleLocationNameChange}
                    />
                    <ErrorMessage message={this.state.errMsgSaveLocation} />
                    <SecButton
                      change={this.state.change}
                      color="green"
                      loading={this.state.updateLoading}
                      onClick={this.updateLocation}
                      title="Speichern"
                    />
                    <ErrorMessage message={this.state.errMsgDeleteLocation} />
                    <SecButton
                      change={true}
                      color="red"
                      loading={this.state.deleteLoading}
                      onClick={this.handleDeleteLocation}
                      title="Örtlichkeit löschen"
                    />
                  </div>
                </>
              )}
          </div>
        </div>
      </>
    );
  }
}
